<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

  <form #df="ngForm" novalidate (keydown.enter)="search()" class="formborder">
    <div class="col-md-12 row">
      <div class="col-md-2">
        <span class="required-lable">To Date</span>
        <input
          name="ToDate"
          [(ngModel)]="ToDate"
          id="ToDate"
          placeholder="To Date"
          class="form-control input-text-css"
          bsDatepicker
          [bsConfig]="{ dateInputFormat: 'MM/YYYY' }"
          (onShown)="onOpenCalendar($event)"
          required
          #refToDate="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && refToDate.invalid,
            'alert-warning':
              refToDate.invalid &&
              (refToDate.dirty || refToDate.touched || refToDate.untouched)
          }"
        />
      </div>

      <div class="col-md-3">
        <span class="">Select</span>
        <select
          name="monthlyType"
          id="monthlyType"
          #refmonthlyType="ngModel"
          [(ngModel)]="monthlyType"
          class="form-control input-text-css"
        >
          <option value="dpd">DPD</option>
          <option value="overdue">Overdue</option>
        </select>
      </div>

      <div class="col-md-2">
        <button
          type="button"
          (click)="search()"
          class="btn font-size-12 button-btn mt-3"
          style="width: max-content"
        >
          Search
        </button>
      </div>

      <div class="col-md-4 mt-3" [hidden]="!dataSource">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>

  <div [hidden]="!dataSource" class="mt-3">
    <div class="table-responsive" style="overflow: auto; height: 65vh">
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        matTableExporter
        #exporter="matTableExporter"
      >
        <ng-container matColumnDef="Loan_Id">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Application_No">
          <th mat-header-cell *matHeaderCellDef>Application No</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Application_No }}
          </td>
        </ng-container>

        <ng-container matColumnDef="LoanAcNo">
          <th mat-header-cell *matHeaderCellDef>Loan Ac No</th>
          <td mat-cell *matCellDef="let element">
            {{ element.LoanAcNo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="LoanCreatedOn">
          <th mat-header-cell *matHeaderCellDef>Loan Created On</th>
          <td mat-cell *matCellDef="let element">
            {{ element.LoanCreatedOn }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Loan_Date">
          <th mat-header-cell *matHeaderCellDef>Loan Date</th>
          <td mat-cell *matCellDef="let element">{{ element.Loan_Date }}</td>
        </ng-container>

        <ng-container matColumnDef="Branch_Name">
          <th mat-header-cell *matHeaderCellDef>Branch Name</th>
          <td mat-cell *matCellDef="let element">{{ element.Branch_Name }}</td>
        </ng-container>

        <ng-container matColumnDef="Product_Name">
          <th mat-header-cell *matHeaderCellDef>Product Name</th>
          <td mat-cell *matCellDef="let element">{{ element.Product_Name }}</td>
        </ng-container>

        <ng-container
          *ngFor="let dynamicColumn of dynamicColumns"
          [matColumnDef]="dynamicColumn"
        >
          <th mat-header-cell *matHeaderCellDef>{{ dynamicColumn }}</th>
          <td
            mat-cell
            *matCellDef="let element"
            style="text-align: left !important"
          >
            {{ element[dynamicColumn] }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="(row)"
          [class.highlight]="row.Loan_Id == selectedId"
        ></tr>
      </table>
    </div>
  </div>
</div>

<div class="row m-0 ml-3" [hidden]="!dataSource">
  <div class="col-md-4 mt-3">
    <button
      class="mt-2 btn font-size-12 button-btn"
      (click)="exportTable(exporter)"
    >
      <i
        class="fa fa-file-export mr-1"
        style="font-size: medium; cursor: pointer"
      ></i>
      Export
    </button>
  </div>
  <div class="col-md-8 mt-2">
    <mat-paginator
      #paginatorRef
      [pageSizeOptions]="[20, 50,100]"
      [pageSize]="50"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
